var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralWaste(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45231 2.33333H7.16064V1.41667C7.16064 1.17355 7.06407 0.940394 6.89216 0.768485C6.72025 0.596577 6.48709 0.5 6.24398 0.5H3.49398C3.25086 0.5 3.0177 0.596577 2.8458 0.768485C2.67389 0.940394 2.57731 1.17355 2.57731 1.41667V2.33333H0.285645V3.25H1.20231V10.125C1.20231 10.4897 1.34718 10.8394 1.60504 11.0973C1.8629 11.3551 2.21264 11.5 2.57731 11.5H7.16064C7.52532 11.5 7.87505 11.3551 8.13292 11.0973C8.39078 10.8394 8.53564 10.4897 8.53564 10.125V3.25H9.45231V2.33333ZM3.49398 1.41667H6.24398V2.33333H3.49398V1.41667ZM7.61898 10.125C7.61898 10.2466 7.57069 10.3631 7.48474 10.4491C7.39878 10.535 7.2822 10.5833 7.16064 10.5833H2.57731C2.45575 10.5833 2.33917 10.535 2.25322 10.4491C2.16727 10.3631 2.11898 10.2466 2.11898 10.125V3.25H7.61898V10.125Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41032 8.2914V5.5414C4.41032 5.28827 4.20511 5.08307 3.95198 5.08307C3.69885 5.08307 3.49365 5.28827 3.49365 5.5414V8.2914C3.49365 8.54453 3.69885 8.74973 3.95198 8.74973C4.20511 8.74973 4.41032 8.54453 4.41032 8.2914Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24382 8.29139V5.5414C6.24382 5.28827 6.03862 5.08307 5.78548 5.08307C5.53235 5.08307 5.32715 5.28827 5.32715 5.54141V8.29139C5.32715 8.54452 5.53235 8.74973 5.78548 8.74973C6.03862 8.74973 6.24382 8.54452 6.24382 8.29139Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralWaste);
export default __webpack_public_path__ + "static/media/GeneralWaste.af0512fccc9d4b6e560243fd3e5f804e.svg";
export { ForwardRef as ReactComponent };